/**
 * Deep-clone a TypedArray (or any ArrayBufferView).
 * Prefers `.slice(0)` when available, falls back to constructor copy.
 */
export const cloneTypedArray = <T extends ArrayBufferView>(src: T): T => {
    const anySrc: any = src as any;
    if (anySrc && typeof anySrc.slice === 'function') {
        return anySrc.slice(0);
    }
    const Ctor: any = (src as any).constructor;
    return new Ctor(src) as T;
};
